"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFirstDirectChildOfTypes = getFirstDirectChildOfTypes;
exports.getDirectChildrenOfType = getDirectChildrenOfType;

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash.find"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/**
 * Utility function for getting the first direct child of a Component that matches a list of types.
 * This function does not traverse the entire component tree, just the direct children.
 * @param children: Component.props.children
 * @param { Array } childTypes: An array of Component type.
 * @returns The first Component instance whose type matches one of the types of `childTypes`.
 * Or `undefined` if nothing matches.
 */
function getFirstDirectChildOfTypes(children) {
  var childTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var childrenArr = _react.default.Children.toArray(children);

  var found = (0, _lodash.default)(childrenArr, function (child) {
    var index = childTypes.indexOf(child.type);
    return index !== -1;
  });
  return found;
}
/**
 * Utility function for getting all direct children of a Component that matches a given type.
 * This function does not traverse the entire component tree, just the direct children.
 * @param children: Component.props.children
 * @param childType: A Component type.
 * @returns All Component instances whose type matches the given type. Or `undefined` if nothing matches or there's no children.
 */


function getDirectChildrenOfType(children, childType) {
  var childrenArr = _react.default.Children.toArray(children);

  if (!childrenArr.length || !childType) return;
  var found = childrenArr.reduce(function (acc, child) {
    if (_react.default.isValidElement(child) && child.type === childType) {
      return [].concat(_toConsumableArray(acc), [child]);
    }

    return acc;
  }, []);
  return found.length === 0 ? undefined : found;
}